// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__i1j-i","navContainer":"Navbar_navContainer__0-j8q","navBrand":"Navbar_navBrand__k78cw","navLinks":"Navbar_navLinks__fYB2m"};